export const ASSET_CACHE_BUDGET_BYTES = 100 * 1024 * 1024;

export function assetByteSize(img: ImageData): number {
  return img.data.byteLength;
}

export function touchAsset(accessOrder: readonly string[], id: string): string[] {
  return [...accessOrder.filter((existing) => existing !== id), id];
}

export function evictAssetDataLRU(
  assetData: Map<string, ImageData>,
  accessOrder: readonly string[],
  budgetBytes = ASSET_CACHE_BUDGET_BYTES,
): {
  assetData: Map<string, ImageData>;
  accessOrder: string[];
  evicted: string[];
} {
  const nextData = new Map(assetData);
  const nextOrder = accessOrder.filter((id) => nextData.has(id));
  const evicted: string[] = [];
  let totalBytes = 0;

  for (const image of nextData.values()) {
    totalBytes += assetByteSize(image);
  }

  while (totalBytes > budgetBytes && nextOrder.length > 1) {
    const id = nextOrder.shift()!;
    const image = nextData.get(id);
    if (image === undefined) continue;
    nextData.delete(id);
    totalBytes -= assetByteSize(image);
    evicted.push(id);
  }

  return { assetData: nextData, accessOrder: nextOrder, evicted };
}
